import React from 'react';
import { Users, UserPlus, UserCheck, RefreshCw } from 'lucide-react';

export function ClientRetention({ data }) {
  const total = (data.new_clients || 0) + (data.returning_clients || 0);
  const newPct = total > 0 ? (data.new_clients / total) * 100 : 0;
  const retPct = total > 0 ? (data.returning_clients / total) * 100 : 0;

  return (
    <div className="card-surface p-6" data-testid="client-retention">
      <h3 className="font-heading text-base font-medium text-[#1A1A1A] mb-4 flex items-center gap-2">
        <Users className="h-4 w-4 text-[#D4AF37]" />
        Client Retention
      </h3>

      {total === 0 ? (
        <p className="text-sm text-stone-400 text-center py-6">No client data for this period.</p>
      ) : (
        <>
          {/* Stacked progress bar */}
          <div className="h-4 rounded-full overflow-hidden flex mb-4" data-testid="retention-bar">
            <div
              className="bg-blue-400 transition-all duration-500"
              style={{ width: `${newPct}%` }}
              title={`New clients: ${data.new_clients}`}
            />
            <div
              className="bg-emerald-500 transition-all duration-500"
              style={{ width: `${retPct}%` }}
              title={`Returning clients: ${data.returning_clients}`}
            />
          </div>

          <div className="grid grid-cols-3 gap-3 text-center">
            <div className="p-3 bg-[#F9F6F0] rounded-lg">
              <UserPlus className="h-4 w-4 text-blue-500 mx-auto mb-1" />
              <p className="text-lg font-bold text-[#1A1A1A]">{data.new_clients}</p>
              <p className="text-xs text-stone-500">New</p>
            </div>
            <div className="p-3 bg-[#F9F6F0] rounded-lg">
              <UserCheck className="h-4 w-4 text-emerald-500 mx-auto mb-1" />
              <p className="text-lg font-bold text-[#1A1A1A]">{data.returning_clients}</p>
              <p className="text-xs text-stone-500">Returning</p>
            </div>
            <div className="p-3 bg-[#F9F6F0] rounded-lg">
              <RefreshCw className="h-4 w-4 text-[#D4AF37] mx-auto mb-1" />
              <p className="text-lg font-bold text-[#D4AF37]">{data.rebooking_rate}%</p>
              <p className="text-xs text-stone-500">Rebook Rate</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
